import { render } from "./adminBugReport.vue?vue&type=template&id=19ee0867&scoped=true"
import script from "./adminBugReport.vue?vue&type=script&lang=js"
export * from "./adminBugReport.vue?vue&type=script&lang=js"

import "./adminBugReport.vue?vue&type=style&index=0&id=19ee0867&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ee0867"]])

export default __exports__